window.Konfigurator = function (config) {
    var _this = this;
    _this.$form = config.form;
    _this.$progressbar = config.progressbar;
    _this.$footer = config.footer;
    _this.urls = config.urls || {}
    _this.current_step = null;
    _this.step_delay = 200;
    _this.last_step_url = '';

    this.initiate = function initiate(){
        _this.events();
        _this.hash();
        _this.last_step_url = _this.get_step_url();
    }

    this.get_step_url = function get_step_url() {
        let hash_step = window.location.hash.substring(1) || 'index';
        hash_step = hash_step.split('%');
        hash_step = hash_step[0].split('&');
        hash_step = hash_step[0].split('#');

        return String(hash_step[0]).replace(/[^a-z0-9-]+/g, '');
    } 

    this.hash = function hash(){
        // Set current step
        _this.current_step = _this.get_step_url();

        if (_this.last_step_url === _this.current_step) {
            return;
        }

        _this.last_step_url = _this.current_step;

        // sidebar
        $('.btn-help').attr('data-content', _this.current_step);

        // Hide previos error message
        $('.error-message').hide();

        // Get step
        let step_url = _this.urls.step.replace('__step__', _this.current_step);

        $.get(step_url, function(data){
            // Scroll to top
            window.scrollTo(0, 0);
            _this.$form.html(data.html);
            _this.add_step_active();
            // Update body (probably used for progressbar)
            _this.add_step_to_body(_this.current_step);
            if(data.progressbar === null){
                //_this.disable_footer();
            } else {
                //_this.enable_footer();
                _this.update_progressbar(data.progressbar);
            }
        }).catch(function(error) {
            let data = error.responseJSON;

            if ([503].includes(error.status)) {
                window.location.reload();
            }

            if (error.status === 404) {
                _this.$form.html('<div style="background-color: #fff; border-radius: 20px; width: 500px; max-width: 100%; margin: 0 auto; padding: 30px 20px; text-align: center;">Steget <strong>'+ _this.current_step +'</strong> hittades inte</div>');
            }

            if (error.status === 500 && data && data.message && data.message === 'session_not_started') {
                if (data.redirect === '/') {
                    window.location.href = '/';
                }
                
                window.location.href = '#'+ data.redirect;
            }
        });
    }

    // For css transition
    this.add_step_active = function add_step_active()
    {
        setTimeout(function(){
            _this.$form.find('.frame').addClass('active');
        }, _this.step_delay);
    }

    this.remove_step_active = function remove_step_active()
    {
        _this.$form.find('.frame').removeClass('active');
    }

    this.changeurl = function changeurl(page, url){
        if (typeof (history.pushState) != 'undefined') {
            var obj = {
                Page: page,
                Url: url
            };
            history.pushState(obj, obj.Page, obj.Url);
        }
    }

    this.add_step_to_body = function add_step_to_body(step)
    {
        // console.log('running body check');
        $('body').removeClass().addClass(step);
    }

    this.disable_footer = function disable_footer(progress)
    {
        /*
        if($('body').hasClass('show-footer')){
            $('body').removeClass('show-footer');
        }
        */
    }

    this.enable_footer = function enable_footer(progress)
    {
        /*
        if(!$('body').hasClass('show-footer')){
            $('body').addClass('show-footer');
        }
        */
    }

    this.update_progressbar = function update_progressbar(progress)
    {
        _this.$progressbar.find('.progress-fill').css('width', progress +'%');
    }

    this.show_error_message = function show_error_message(errors, display = false)
    {
        let show_custom_message = display;
        let custom_message = '';

        // show message
        $.each(errors, function(id, message) {
            if(id === 'age'){
                custom_message = message[0];
                show_custom_message = true;
            }
            if(id === 'startdatum'){
                custom_message = message[0];
                show_custom_message = true;
            }
            if(id === 'livvarde'){
                custom_message = message[0];
                show_custom_message = true;
            }
            if(id === 'regnr'){
                custom_message = message[0];
                show_custom_message = true;
            } else {
                custom_message = message[0];
            }
        });

        if(show_custom_message){
            $('.validation-error-message').hide();
            $('.custom-error-message').html(custom_message).show();
        } else {
            $('.custom-error-message').hide();
            $('.validation-error-message').show();
        }

        let timer_index = Math.floor(Math.random() * 100);
        $('.error-message-wrapper').attr('data-timer-index', timer_index).slideDown(300);
        setTimeout(function(){
            $('.error-message-wrapper[data-timer-index='+timer_index+']').slideUp(300);
        },10000);

    }

    // Close sidebar
    this.sidebar_close = function sidebar_close()
    {
        $('body').removeClass('sidebar-open');
        $('.app-sidebar-content').fadeOut(300);
    }

    this.disable_form_next_button = function disable_form_next_button($button, text)
    {
        if ($button.find('i').length === 0) {
            text = '<i class="fa fa-spinner fa-spin"></i> '+text;
        }

        $button.html(text);
        $button.addClass('disabled');
        $button.prop('disabled', true);
    }

    this.enable_form_next_button = function disable_form_next_button($button, text)
    {
        $button.html(text);
        $button.find('i').remove();
        $button.removeClass('disabled');
        $button.prop('disabled', false);
    }

    this.go_back = function go_back()
    {
        history.back();
    }

    this.reset_steps = function reset_steps()
    {
        _this.remove_step_active();
        setTimeout(function(){
            _this.changeurl('index','/')
            _this.hash();
            _this.sidebar_close();
            _this.update_progressbar(10);
        }, _this.step_delay);
    }

    this.events = function events()
    {

        // On hash change
        window.onhashchange = _this.hash;

        // Ajax setup for csrf verification
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        // On click back
        $('.btn-back').on('click', function(e){
            e.preventDefault();
            _this.go_back();
        });

        // On reset step button
        $('.btn-reset').on('click', function(e){
            e.preventDefault();
            _this.reset_steps();
        });

        _this.$form.on('click', '.box-button', function(e){
            e.preventDefault();
            $('#' + $(this).data('id')).attr('checked', true);
        });

        // On click trigger submit
        _this.$form.on('click', '.btn-select', function(e) {
            e.preventDefault();
            _this.$form.trigger('submit');
        });

        // On change trigger submit
        _this.$form.on('click', '.Choice--auto-submit .Choice__option input', function(e) {            
            _this.$form.trigger('submit');
        });

        // On next, trigger submit
        _this.$form.on('click', '.btn-next', function(e) {
            e.preventDefault();
            let skip = parseInt($(this).data('skip') || 0);
            if(_this.$form.find('input[name=skip]').length > 0){
                _this.$form.find('input[name=skip]').remove();
            }
            if(skip === 1){
                _this.$form.append('<input type="hidden" name="skip" value="1" />');
            }
            _this.$form.trigger('submit');
        });

        // On next, trigger submit
        _this.$form.on('click', '.btn-next-bubble', function(e) {
            e.preventDefault();
            let skip = parseInt($(this).data('skip') || 0);
            if(_this.$form.find('input[name=skip]').length > 0){
                _this.$form.find('input[name=skip]').remove();
            }
            if(skip === 1){
                _this.$form.append('<input type="hidden" name="skip" value="1" />');
            }
            _this.$form.trigger('submit');
        });

        // On click bubble
        _this.$form.on('click', '.bubble-select label', function() {
            var ancestor = $(this).parents('.bubble-select');
            parent = $(this).parent('li');
            ancestor.children('li').removeClass('selected');
            ancestor.find('input[type=checkbox]').prop('checked', false);
            parent.addClass('selected');
            parent.next('input[type=checkbox]').prop('checked', true);
        });

        // on bubble skip to next step
        _this.$form.on('click', '.bubble-select-next', function() {
            _this.$form.trigger('submit');
        });

        // On form validation
        _this.$form.on('submit', function(e){            
            e.preventDefault();

            // Hide previous error message
            $('.error-message-wrapper').slideUp(300);
            $('.question-wrapper').removeClass('error');

            let step_validate_url = _this.urls.validate.replace('__step__', _this.current_step);
            // Form
            var $form = $(this);

            // Add spinning to button
            let $button = $form.find('button.btn-next').not('[data-skip=1]');
            let buttonText = $button.html();

            _this.disable_form_next_button($button, buttonText);

            for (let error_div of Array.from(document.querySelectorAll('[data-error]'))) {
                error_div.innerHTML = '';
            }

            // Check validation
            $.post(step_validate_url, $form.serialize(), function(data){
                    // If status == 1 and next_step is not null
                    if(data.status == 1){
                        if(data.next_step != ''){
                            _this.remove_step_active();
                            setTimeout(function(){
                                _this.changeurl(data.next_step,'#'+data.next_step)
                                _this.hash();
                                _this.sidebar_close();
                            }, _this.step_delay);
                        }
                    } else {
                        // error to submit validation
                        if(data.errors){
                            let display = (data.display) ? data.display : 0;

                            _this.show_error_message(data.errors, display);

                            // Handle errors on hälsodeklarationen
                            $.each(data.errors, function(id, message) {
                                let key_split = id.split('.');
                                if(key_split[0] === 'questions'){
                                    let question_id = key_split[1];
                                    _this.$form.find('[data-question-id='+question_id+']').addClass('error');
                                }
                            });
                        }
                        // enable button
                        _this.enable_form_next_button($button, buttonText);
                    }

                }, 'json')
                .catch(function(error) {
                    let custom_error = false;
                    let errors = error.responseJSON.errors;

                    for (let field in errors) {
                        let element = document.querySelector('[data-error="' + field + '"]');
                        let message = errors[field][0];

                        if (element && message) {
                            custom_error = true;
                        }
                    }

                    setTimeout(function() {
                        for (let field in errors) {
                            let element = document.querySelector('[data-error="' + field + '"]');
                            let message = errors[field][0];

                            if (element && message) {
                                element.innerHTML = message;
                                element.style.display = 'block';
                            }
                        }

                        if (Object.keys(errors).length > 0) {
                            setTimeout(() => {
                                window.scrollto.selector('[name='+ Object.keys(errors)[0] +']', 120);
                            }, 250);
                        }
                    }, 500);

                    if ([419, 503].includes(error.status)) {
                        window.location.reload();
                    } else if (!custom_error) {
                        _this.show_error_message(errors, 0);
                    }

                    setTimeout(() => {
                        _this.enable_form_next_button($button, buttonText);
                    }, 500);
                })
                .fail(function(){
                    // enable button
                    _this.enable_form_next_button($button, buttonText);
                });
        });
    }

    // Initiate this object
    this.initiate();
}

jQuery(function() {
    $('body').on('click', '.btn-sidebar', function(e) {
        var data = $(this).attr('data-content');

        if(!$('body').hasClass('sidebar-open') && $('.app-sidebar-'+data).css('display') === 'block'){
            return;
        }
        
        e.preventDefault();

        $('.app-sidebar-content').hide();
        $('.app-sidebar-'+data).show();
        $('body').addClass('sidebar-open');
    });

    $('#app-sidebar').on('click', '.app-sidebar-x', function(e) {
        e.preventDefault();
        $('body').removeClass('sidebar-open');
        $('.app-sidebar-content').fadeOut(300);
    });

    $('#app').click(function(e) {
      if($('body').hasClass('sidebar-open')){
        $('body').removeClass('sidebar-open');
        $('.app-sidebar-content').fadeOut(300);
      }
    });

    $('body').on('keyup', '[name]', function(e) {
        if (e.code !== 'Enter') {
            var error = $('[data-error="' + $(this).attr('name') + '"]');

            if (error) {
                error.text('');
                error.hide();
            }
        }
    });
});

window.formatAsDate = function(input, e) {
    input = String(input).replace(/[^0-9]/g, '');

    if (input.length >= 8) {
        input = input.substring(0, 4) + '-' + input.substring(4, 6) + '-' + input.substring(6, 8);
    } else if (input.length >= 7) {
        input = input.substring(0, 4) + '-' + input.substring(4, 6) + '-' + input.substring(6);
    } else if (input.length >= 4) {
        input = input.substring(0, 4) + '-' + input.substring(4);
    }

    input = input.replace(/-$/, '');

    if (e.key === '-') {
        input = input + '-';
    }

    return input;
}

window.formatAsPersonalNumber = function(input, e) {
    input = String(input).replace(/[^0-9]/g, '');

    if (input.length >= 10) {
        input = input.substring(0, 8) + '-' + input.substring(8, 12);
    } else if (input.length === 2 && !['19', '20'].includes(input)) {
        if (parseInt(input) > 20) {
            input = '19' + input;
        } else {
            input = '20' + input;
        }
    }

    input = input.replace(/-$/, '');

    if (e.key === '-') {
        input = input + '-';
    }

    return input;
}